var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.6645V3.16345C1 2.2426 1.7465 1.49609 2.66736 1.49609H8.64652C9.08869 1.49609 9.51272 1.67192 9.82534 1.98463L12.183 4.34228C12.4957 4.6549 12.6715 5.07893 12.6715 5.5211V14.835C12.6715 15.7558 11.925 16.5023 11.0042 16.5023H2.66736C1.7465 16.5023 1 15.7558 1 14.835V14.0013",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.6645V3.16345C1 2.2426 1.7465 1.49609 2.66736 1.49609H8.64652C9.08869 1.49609 9.51272 1.67192 9.82534 1.98463L12.183 4.34228C12.4957 4.6549 12.6715 5.07893 12.6715 5.5211V14.835C12.6715 15.7558 11.925 16.5023 11.0042 16.5023H2.66736C1.7465 16.5023 1 15.7558 1 14.835V14.0013V5.6645Z",
    stroke: "#3158F2",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_52452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.6645V3.16345C1 2.2426 1.7465 1.49609 2.66736 1.49609H8.64652C9.08869 1.49609 9.51272 1.67192 9.82534 1.98463L12.183 4.34228C12.4957 4.6549 12.6715 5.07893 12.6715 5.5211V14.835C12.6715 15.7558 11.925 16.5023 11.0042 16.5023H2.66736C1.7465 16.5023 1 15.7558 1 14.835V14.0013",
    fill: "#848484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.6645V3.16345C1 2.2426 1.7465 1.49609 2.66736 1.49609H8.64652C9.08869 1.49609 9.51272 1.67192 9.82534 1.98463L12.183 4.34228C12.4957 4.6549 12.6715 5.07893 12.6715 5.5211V14.835C12.6715 15.7558 11.925 16.5023 11.0042 16.5023H2.66736C1.7465 16.5023 1 15.7558 1 14.835V14.0013V5.6645Z",
    stroke: "#848484",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_52452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13477 11.0316H8.48294",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13477 13.707H5.80885",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1743 5.66319H9.33954C8.87911 5.66319 8.50586 5.28994 8.50586 4.82951V-0.171875",
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1743 5.66319H9.33954C8.87911 5.66319 8.50586 5.28994 8.50586 4.82951V-0.171875",
    stroke: "#91A5F2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.375d12703813a3a5d0cbf35f49d7ae16.svg";
export { ForwardRef as ReactComponent };